import {Component, OnInit} from '@angular/core';
import {Params, RouterOutlet} from '@angular/router';

import {JWTPayload} from 'jose';
import * as jose from 'jose';

import {AppService, LocalStorageService} from 'shared/services';
import {TokenUserModel} from 'shared/models';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected title: string = 'mitorneo.app';

  constructor(
    private appService: AppService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.loadCurrentUser();
  }

  private loadCurrentUser(): void {
    const token: string | null = this.localStorageService.getItem('t');
    if (token) {
      const claims: JWTPayload = jose.decodeJwt(token);
      const tokenUser: TokenUserModel = TokenUserModel.getInstance(claims['data'] as Params);

      this.appService.token = token;
      this.appService.currentUser = tokenUser;
    }
  }
}
